const state = {
    snackbar : false,
    color: '',
    multiline: 'multi-line',
    timeout: 6000,
    vertical:'vertical',
    text:''
};

const getters = {
    getSnackbar: state => {
        return state.snackbar;
    },
    getColor: state => {
        return state.color;
    },
    getMultiline: state => {
        return state.multiline;
    },
    getTimeout: state => {
        return state.timeout;
    },
    getVertical: state => {
        return state.vertical;
    },
    getText: state => {
        return state.text;
    },

};

const actions = {
};

const mutations = {
    setSnackbar: (state,value) => {
        state.snackbar = value;
    },
    setColor: (state,value) => {
        state.color = value;
    },
    setMultiline: (state,value) => {
        state.multiline = value;
    },
    setSnackTimeout: (state,value) => {
        state.timeout = value;
    },
    setVertical: (state,value) => {
        state.vertical = value;
    },
    setText: (state,value) => {
        state.text = value;
    }
};



export default {
    namespaced : true,
	state,
	mutations,
	getters,
	actions
}
